import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Receipt, ChevronRight } from 'lucide-react'
import { Card, CardContent } from '../../../components/ui/card'
import { useDuesThisMonth } from '../../../hooks/usePendingFinanceEvents'
import DuesSheet from './DuesSheet'
import { cn } from '../../../lib/utils'

// Tappable card surfaced on the Finance page when there are still
// unsettled monthly items. Tap → opens the <DuesSheet />. Hides
// completely when everything's already paid (so it doesn't shout at
// you for clean months).

export default function DuesBanner() {
  const { t } = useTranslation()
  const { unsettledCount, unsettledTotal, loading } = useDuesThisMonth()
  const [open, setOpen] = useState(false)

  if (loading || unsettledCount === 0) return null

  return (
    <>
      <Card
        role="button"
        tabIndex={0}
        onClick={() => setOpen(true)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setOpen(true) }}
        className={cn(
          'border-app-primary-500/30 cursor-pointer transition-colors',
          'hover:border-app-primary-500/60 hover:bg-app-primary-500/5',
        )}
      >
        <CardContent className="p-3 flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-app-primary-500/10 flex items-center justify-center flex-shrink-0">
            <Receipt className="w-4 h-4 text-app-primary-500" />
          </div>
          <div className="flex-1 min-w-0" dir="auto">
            <p className="text-sm font-semibold text-foreground">
              {t('dues.banner.title', { count: unsettledCount })}
            </p>
            <p className="text-[11px] text-muted-foreground">
              {t('dues.banner.subtitle')} ·{' '}
              <span className="font-mono" dir="ltr">
                {unsettledTotal < 0 ? '−' : '+'}
                {Math.abs(unsettledTotal).toLocaleString('en-US', { maximumFractionDigits: 0 })} SAR
              </span>
            </p>
          </div>
          <ChevronRight className="w-4 h-4 text-muted-foreground rtl:-scale-x-100 flex-shrink-0" />
        </CardContent>
      </Card>
      <DuesSheet open={open} onClose={() => setOpen(false)} />
    </>
  )
}
